
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandP as ObiOwnShipNoCommandPElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-p.js';
 
 
 

 
 export const ObiOwnShipNoCommandP = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-p',
   elementClass: ObiOwnShipNoCommandPElement,
   events: {
     
   }
  });
 
 